import { Component, ElementRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "downloadfile",
    templateUrl: "./downloadfile.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class DownloadFileComponent {
    @ViewChild("excelAnchor") excelAnchor: ElementRef;
    excelUrl: SafeUrl;
    downloadFileName: string;

    constructor(private sanitizer: DomSanitizer) {
    }

    downloadExcel(fileName: string, response: any): void {
        this.downloadFile(fileName, response, "xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }

    /**
     * performs the download of the files
     * @param fileName name to give the file to download
     * @param response the response object to set as the attachment
     */
    downloadFile(fileName: string, response: any, extension: string, type: string): void {
        this.downloadFileName = `${fileName}.${extension}`;
        this.excelUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(response));
        const excelAnc: ElementRef = this.excelAnchor;
        // need setTimeout as it fires before the anchor is set
        setTimeout(() => {
            const blob: Blob = new Blob([response], { type: type });
            if ((window.navigator as any).msSaveBlob) { // for IE
                (window.navigator as any).msSaveOrOpenBlob(blob, `${fileName}.${extension}`);
            } else { // for Chrome
                excelAnc.nativeElement.click();
            }
        }, 100);
    }
}
